import React, { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Grid, Typography, InputBase, Tooltip, Paper } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import ChatIcon from "@material-ui/icons/Chat";
import AttachFileIcon from "@material-ui/icons/AttachFile";
import SendIcon from "@material-ui/icons/Send";
import moment from "moment";

import CircularProgress from "@material-ui/core/CircularProgress";
import axios from "axios";
import {
  Box,
  TextField,
  IconButton,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import jwtDecode from "jwt-decode";
import GetAppIcon from '@material-ui/icons/GetApp';
import { appUrl } from "../../../../../../utils/config";

const useStyles = makeStyles((theme) => ({
  chatHeading: {
    border: "1px solid #000000de",
    padding: "10px 4px 10px 4px",
    display: "flex",
    justifyContent: "space-between",
    backgroundColor: "white",
  },
  chatSpace: {
    flex: 1,
    border: "1px solid #000000de",
    borderTop: "0px",
    borderBottom: "0px",
    backgroundColor: "#E7ECEE",
    display: "flex",
    flexDirection: "column",
    overflowY: "auto",
    maxHeight: "500px", // Set the maximum height to 500px
  },
  chatBox: {
    border: "1px solid #000000de",
    padding: "10px 4px 10px 4px",
    display: "flex",
    alignItems: "center",
  },
  chatInput: {
    width: "300px",
    marginRight: "8px",
  },
  fileAdded: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-end",
    paddingLeft: "8px",
    paddingRight: "8px",
    backgroundColor: "#e36e39",
    borderBottomLeftRadius: "8px",
    borderBottomRightRadius: "8px",
    position: "sticky",
    // bottom: 180,
    zIndex: 1,
  },
  // messages: {
  //   display: "flex",
  //   flexDirection: "column",
  // },

  chatMessageContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start", // Align all messages to the left
    height: "580px",
  },

  chatMessage: {
    padding: "8px",
    width: "80%",
    borderRadius: "8px",
    marginBottom: "10px",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start", // Align text and email to the left
  },

  textMessage: {
    fontSize: "0.8rem",
    marginTop: "4px",
  },

  myChat: {
    alignSelf: "flex-start", // Align your messages to the left
    backgroundColor: "#dcf8c6",
    color: "#000000de",
    textAlign: "left",
    marginRight: "8px", // Add margin to your messages on the left
  },

  contactChat: {
    alignSelf: "flex-start", // Align others' messages to the left
    backgroundColor: theme.palette.background.default,
    textAlign: "left",
    marginLeft: "8px", // Add margin to others' messages on the left
  },

  emailTextContact: {
    fontSize: "0.8rem",
    color: "#2196f3",
    textAlign: "left", // Ensure email is aligned to the left
  },

  emailTextSelf: {
    fontSize: "0.8rem",
    color: "#e36e39",
    textAlign: "left", // Ensure email is aligned to the left
  },

  timeText: {
    fontSize: "0.6rem",
    color: theme.palette.text.secondary,
    textAlign: "left",
  },
}));

const POLineChat = (props) => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const {poNumber,vendorMosymphonyID, lineItemNumber, schrockenPOLineID,
    } = props;
    const [loading, setLoading] = useState(false);
    const [messages, setMessages] = useState([]);
    const [error, setError] = useState("");
    const [newMessage, setNewMessage] = useState("");
    const tokenData = jwtDecode(localStorage.getItem("authToken"));
    const [file, setFile] = useState(null);
    const [fileURLs, setFileURLs] = useState({});
     const [chatData, setChatData] = useState(null);
    const chatContainerRef = useRef(null);
    const currentDate = new Date().toLocaleString();
    const [sendMessageLoading, setMessageLoading] = useState(false);
  
     const scrollChatToBottom = () => {
      if (chatContainerRef.current) {
        chatContainerRef.current.scrollTop =
          chatContainerRef.current.scrollHeight;
      }
    };
  
   const handleSendMessage = async () => {
    if (newMessage.trim() !== "" || file) {
      // setLoading(true);
      setMessageLoading(true)
      // Generate object URL for the attached file
      // let fileURL = null;
      // if (file) {
      //   fileURL = URL.createObjectURL(file);
      //   setFileURLs((prevURLs) => ({
      //     ...prevURLs,
      //     [file.name]: fileURL,
      //   }));
      // }
  
      // setMessages([
      //   ...messages,
      //   {
      //     sender: tokenData.full_name,
      //     time: moment(currentDate, "M/D/YYYY, h:mm:ss A").format("MMM DD, YYYY HH:mm"),
      //     text: newMessage,
      //     type: "sent",
      //     file: file ? file.name : null,
      //     // fileURL: fileURL,
      //   },
      // ]);
      setNewMessage("");
      setFile(null);
  
      // Prepare FormData
      const formData = new FormData();
      formData.append("purchaseOrderNumber", poNumber);
        formData.append("vendorMosymphonyID", vendorMosymphonyID);
        formData.append("lineItemNumber", lineItemNumber);
      formData.append("schrockenPOLineID", schrockenPOLineID);
      formData.append("chatDataObject", JSON.stringify({
        chatSenderName: tokenData.full_name,
        chatSenderEmail: tokenData.email_address,
        chatTimestamp: new Date().toISOString(),
        chatData: newMessage,
        chatFileHash: file ? "notempty" : "",
        chatFileName: file ? file.name : "",
      }));
      formData.append("createdBy", tokenData.full_name);
      formData.append("lastUpdatedBy", tokenData.full_name);
      if (file) {
        formData.append("files", file); // Attach the file
      }
  
      try {
        // Send the form data using Axios
        const response = await axios.post(
          `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/addPOLineItemChatData`,
          formData
        );
  
        if (response.data.status) {
          setError("");
          setTimeout(() => {
            let data = {
                schrockenPOLineID: schrockenPOLineID,
            };
        axios
            .post(
              `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchPOLineItemChatData`,
              data
            )
            .then((res) => {
              if (res.data.status && res.data.chatData) {
                
                setError("");
                // Transform API data into the format used in `messages`
                const formattedMessages = res.data.chatData.map((chat) => ({
                  sender: chat.chatSenderName,
                  time: moment(chat.chatTimestamp).format("DD-MMM-YYYY HH:mm").toUpperCase(),
                  text: chat.chatData,
                  type: chat.chatSenderEmail === tokenData.email_address ? "sent" : "received",
                  file: chat.chatFileName || null,
                  // fileURL: chat.chatFileHash ? `${appUrl}/files/${chat.chatFileHash}` : null,
                  schrockenChatID:chat.schrockenChatID || null,
                  chatFileHash:chat.chatFileHash || null,
                }));
        
                // Set the messages state with the fetched data
                // setMessages(formattedMessages);
                // setLoading(false);
                setMessageLoading(false)
                setTimeout(() => {
                  setMessages(formattedMessages);
                  scrollChatToBottom();
                }, 200);
              } else {
                // setLoading(false);
              setMessageLoading(false)
              setError("Something went wrong. Please try again.");
              }
            })
            .catch((err) => {
              // setLoading(false);
              setMessageLoading(false)
              setError("Something went wrong. Please try again.");
              console.error(err);
              // setStatus(false);
            })
          },1000)
          // console.log("Chat data successfully sent!");
            
        }
      } catch (error) {
        // setLoading(false)
        setMessageLoading(false)
        console.error("Error sending chat data:", error);
        setError("Something went wrong. Please try again.");
      }
  
    }
  };
  
  const handleFileUpload = (event) => {
      const file = event.target.files[0];
      if (file) {
        setFile(file); // Store the file in state
        //console.log("Uploaded file:", file);
      }
    //   if (file) {
    //     // const fileURL = URL.createObjectURL(file);
    //     setFile(file);
    //     setFileURLs((prevURLs) => ({
    //       ...prevURLs,
    //       [file.name]: fileURL,
    //     }));
    // };
  }
  
  
  useEffect(() => {
    if (schrockenPOLineID) {
      setLoading(true);
  let data = {
    schrockenPOLineID: schrockenPOLineID,
      };
  axios
      .post(
        `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchPOLineItemChatData`,
        data
      )
      // .then((res) => {
      //   if (res.data.status) {
      //     setChatData(res.data.chatData);
      //   }
      // })
      .then((res) => {
        if (res.data.status && res.data.chatData) {
          setLoading(false);
          setError("");
          // Transform API data into the format used in `messages`
          const formattedMessages = res.data.chatData.map((chat) => ({
            sender: chat.chatSenderName,
            time: moment(chat.chatTimestamp).format("DD-MMM-YYYY HH:mm").toUpperCase(),
            text: chat.chatData,
            type: chat.chatSenderEmail === tokenData.email_address ? "sent" : "received",
            file: chat.chatFileName || null,
            // fileURL: chat.chatFileHash ? `${appUrl}/files/${chat.chatFileHash}` : null,
            schrockenChatID:chat.schrockenChatID || null,
            chatFileHash:chat.chatFileHash || null,
          }));
  
          // Set the messages state with the fetched data
          setMessages(formattedMessages);
          setTimeout(() => {
            scrollChatToBottom();
          }, 100);
        }
      })
      .catch((err) => {
        setLoading(false);
        //console.log(err)
        setError("Something went wrong. Please try again.");
      })
  } 
  }, [schrockenPOLineID]);
  
  const handleDownloadFile = (schrockenChatID) =>{
    let data = {
      docType : "chat",
      schrockenChatID,
    };
    //console.log(data)
    setLoading(true);
    axios
      .post(
        `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/downloadChatFile`,
        data
      )
      .then((res) => {
         if (res.data.status) {
                let fileDataArray = res.data.fileData.data;
                var byteArray = new Uint8Array(fileDataArray);
        
                var a = window.document.createElement('a');
        
                a.href = window.URL.createObjectURL(
                  new Blob([byteArray], { type: 'application/octet-stream' })
                );
                a.download = res.data.fileName;
        
                document.body.appendChild(a);
                a.click();
           document.body.removeChild(a);
           setLoading(false);
           setTimeout(() => {
            scrollChatToBottom();
          }, 100);
         } else {
           setLoading(false);
           setTimeout(() => {
            scrollChatToBottom();
          }, 100);
  }
      })
      .catch((err) => {
        //console.log(err)
        setLoading(false);
        setTimeout(() => {
          scrollChatToBottom();
        }, 100);
      });
  }

  

  return (
    <Grid container direction="column">
      <Grid item className={classes.chatHeading}>
        <Typography>Review Comments</Typography>
        <ChatIcon />
          </Grid>
          <Box flexGrow="1" padding="10px" overflow="auto" style={{minHeight:'300px'}} bgcolor="#e7ecee" ref={chatContainerRef}>
            {loading ? (
              <div style={{ display:'flex',alignItems:'center',justifyContent:'center',marginTop:'5rem' }}>
           <CircularProgress color='primary' thickness={7} />
          </div>
            ) : error ? (
              <div           
              style={{
                border: '2px solid rgb(255,0,0)',
                backgroundColor: 'rgb(255,240,240)',
                Opacity: 1,
                textAlign: 'center',
                padding: '0.8rem',
                fontSize: '0.875rem',
                marginTop:'4rem',
              }}>
              <Typography color="error" style={{ textAlign: "center", margin: "10px 0" }}>
                {error}
              </Typography>
              </div>
          ) : (
                    messages.map((msg, index) => (
                       <Box
                         key={index}
                         display="flex"
                         flexDirection="column"
                         alignItems={msg.type === "sent" ? "flex-end" : "flex-start"}
                         marginBottom="15px"
                       >
                         <Box
                           bgcolor={msg.type === "sent" ? "#dcf8c6" : "#ffffff"}
                           color="black"
                           padding="10px"
                           borderRadius="15px"
                           maxWidth="80%"
                           boxShadow="0px 4px 6px rgba(0, 0, 0, 0.1)"
                          // boxShadow={1}
                          style={{
                             alignSelf: msg.type === "sent" ? "flex-end" : "flex-start",
                             marginLeft: msg.type === "received" ? "10px" : "auto",
                             marginRight: msg.type === "sent" ? "10px" : "auto",
                          }}
                        >
                          <Typography
                            variant="body2"
                            style={{ fontWeight: "bold",
                              color: msg.type === "sent" ? "#ef7b52" : "green"
                             }}
                          >
                            {msg.sender}
                           </Typography>
                          <Typography
                            variant="caption"
                            style={{
                              color: "#929292",
                              textAlign: "left",
                              fontSize: "0.75rem",
                            }}
                          >
                            {msg.time}
                          </Typography>
                          <Typography variant="body2" style={{ marginBottom: "5px" }}>
                            {msg.text}
                          </Typography>
                          {msg.file && (
                            <Typography
                      variant={'body2'}
                      className={classes.link}
                      style={{
                        textDecoration: 'underline',
                        display:'flex',
                         }}
                         onClick={() =>handleDownloadFile(msg.schrockenChatID)}
                            >
                              <GetAppIcon fontSize='small' style={{color:'blue'}} />
                                              {msg.file}
                                              {/* {loading && (
                                                <CircularProgress
                                                  size={14}
                                                  style={{
                                                    marginLeft: 8, // Add spacing between the file name and spinner
                                                  }}
                                                  />
                                                )} */}
                                                      </Typography>
                                                            )}
                                                          </Box>
                                                        </Box>
                                                      ))
                                        )}

          </Box>
          <Box
            display="flex"
            flexDirection="column"
            alignItems="flex-start"
            // padding="10px"
            borderTop="1px solid #ddd"
          >
            {/* File Preview */}
            {/* {file && (
              <Box
                display="flex"
                alignItems="center"
                bgcolor="#f1f1f1"
                padding="5px"
                borderRadius="5px"
                marginBottom="5px"
                width="100%"
              >
                <Typography variant="body2" style={{ marginRight: "10px" }}>
                  {file.name}
                </Typography>
                <IconButton size="small" onClick={() => setFile(null)}>
                  <CloseIcon fontSize="small" />
                </IconButton>
              </Box>
            )} */}

          {/* Chat Input */}
          <Box
            display="flex"
            alignItems="center"
                  // padding="10px"
                  width={'100%'}
            border="1px solid black"
          >
                  {/* <IconButton color="primary" component="label">
        <AttachFileIcon style={{color:'black'}} />
        <input
          type="file"
          hidden
          onChange={handleFileUpload}
                    accept=".csv,.xls,.xlsx,.pdf,.jpeg,.png,.jpg,.bmp,.doc,.docx"
        />
      </IconButton> */}
            <TextField
              placeholder="Type your comment here..."
              variant="outlined"
              size="small"
                      fullWidth
                      style={{margin:'10px'}}
              value={newMessage}
              onChange={(e) => setNewMessage(e.target.value)}
              onBlur={(e) => {
                const { value } = e.target;
                // Trim leading and trailing spaces for string values
                if (typeof value === "string" && value.trim() !== value) {
                  setNewMessage(value.trim());
                }
              }}
              onKeyPress={(e) => {
                          const {  value } = e.target;
                          if(e.key === "Enter"){
                            setNewMessage(value.trim());
                            handleSendMessage()
                          }
                        }}
                />
                {sendMessageLoading ? 
                  <IconButton
                  style={{ marginLeft: "10px" }}
                >
                    <CircularProgress color='primary' size={'25px'} thickness={3} />
                    </IconButton>
                  :
<IconButton
              color="primary"
              onClick={handleSendMessage}
            //   style={{ marginLeft: "10px" }}
            >
              <SendIcon />
            </IconButton>
                }
            
          </Box>
          </Box>
      
    </Grid>
  );
};

export default POLineChat;
